var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    _vm._g(
      {
        attrs: {
          id: `it-dialog-${_vm.actionText.toLowerCase()}`,
          disabled: _vm.disabled,
          outlined: !_vm.color,
          color: "grey-900",
          dark: Boolean(_vm.color),
        },
        on: {
          click: function ($event) {
            return _vm.$emit("click", this)
          },
        },
      },
      _vm.on
    ),
    [
      _vm.icon && !_vm.icon.right
        ? _c(
            "v-icon",
            _vm._b(
              { domProps: { textContent: _vm._s(_vm.icon.text) } },
              "v-icon",
              _vm.icon,
              false
            )
          )
        : _vm._e(),
      _vm._v(" " + _vm._s(_vm.actionText) + " "),
      _vm.icon && _vm.icon.right
        ? _c(
            "v-icon",
            _vm._b(
              { domProps: { textContent: _vm._s(_vm.icon.text) } },
              "v-icon",
              _vm.icon,
              false
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }